import * as React from 'react';
import moment from 'moment';

type AppointmentDateProps = {
  isActive: boolean;
  appointmentDate: string;
};

const AppointmentDate = ({
  appointmentDate,
  isActive,
}: AppointmentDateProps) => {
  const appointmentDateClassName = isActive
    ? 'appointment-date__day-of-month appointment-date__day-of-month--active'
    : 'appointment-date__day-of-month';

  return (
    <div className="appointment-date">
      <div className={appointmentDateClassName}>
        {moment(appointmentDate).format('D')}
      </div>
      <div className="appointment-date__month-and-day">
        {moment(appointmentDate).format('MMM, ddd').toUpperCase()}
      </div>
    </div>
  );
};

export default AppointmentDate;
